import { PriceDisplay, PriceDisplayEnum } from 'src/areas/product/types';
import { Price } from '../../../../../../types';
import { SortOptionEnum } from '../../offer-list-sorting/types';
import { IListPrices, IPriceListPanelProps, ICommonListProps } from '../types';

export function getListLimits(prices: IListPrices, isGroupedList: boolean) {
  const mainLimit = isGroupedList ? 10 : 15;
  const secondaryLimit = 5;
  const mainListLimit =
    prices.mainList.length <= mainLimit ? prices.mainList.length : mainLimit;
  const secondaryListLimit =
    prices.secondaryList && prices.secondaryList.length <= secondaryLimit
      ? prices.secondaryList.length
      : secondaryLimit;
  return { mainListLimit, secondaryListLimit };
}

export function getListPrices(
  sortedPrices: Price[] | null | undefined,
  splitList: boolean,
  currentSorting: SortOptionEnum,
  priceDisplay: PriceDisplay
): IListPrices {
  if (!splitList) {
    return { mainList: sortedPrices || [], secondaryList: null };
  }

  const showPricesWithShipping =
    priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

  if (
    currentSorting === SortOptionEnum.RECOMMENDED ||
    currentSorting === SortOptionEnum.PRICEANDSTOCKSTATUS
  ) {
    if (showPricesWithShipping) {
      return {
        mainList:
          sortedPrices?.filter(
            f => !f.uncertainData && f.price?.inclShipping
          ) || [],
        secondaryList:
          sortedPrices?.filter(
            f => f.uncertainData || !f.price?.inclShipping
          ) || [],
      };
    }

    return {
      mainList: sortedPrices?.filter(f => !f.uncertainData) || [],
      secondaryList: sortedPrices?.filter(f => f.uncertainData) || [],
    };
  }

  return {
    mainList: sortedPrices?.filter(f => f.price?.inclShipping) || [],
    secondaryList: sortedPrices?.filter(f => !f.price?.inclShipping) || [],
  };
}

export const getCommonListProps = (
  props: IPriceListPanelProps
): ICommonListProps => {
  return {
    productId: props.productId,
    productName: props.productName,
    media: props.media,
    brand: props.brand,
    campaign: props.campaign,
    priceDisplay: props.priceDisplay,
    currentSorting: props.currentSorting,
    adOffset: props.adOffset,
  };
};
